const PATHS = {
    close: <path d="M18 6 6 18M6 6l12 12" />,
    arrowRight: <path d="M5 12h14m0 0-6-6m6 6-6 6" />,
    arrowLeft: <path d="M19 12H5m0 0 6-6m-6 6 6 6" />,
    arrowUp: <path d="M12 19V5m0 0-6 6m6-6 6 6" />,
    chevLeft: <path d="m15 18-6-6 6-6" />,
    chevRight: <path d="m9 18 6-6-6-6" />,
    chevDown: <path d="m6 9 6 6 6-6" />,
    plus: <path d="M12 5v14M5 12h14" />,
    upload: (
        <>
            <path d="M12 16V4m0 0-4.5 4.5M12 4l4.5 4.5" />
            <path d="M4 15v3a2.5 2.5 0 0 0 2.5 2.5h11A2.5 2.5 0 0 0 20 18v-3" />
        </>
    ),
    check: <path d="m20 6-11 11-5-5" />,
    // Drawn so the triangle's centre of mass (not its bounding box) sits on the icon centre: it looks centred inside circles.
    play: <path d="M7.6 5.5v13a1 1 0 0 0 1.5.86l10.5-6.5a1 1 0 0 0 0-1.72L9.1 4.64A1 1 0 0 0 7.6 5.5Z" fill="currentColor" stroke="none" />,
    soundOn: (
        <>
            <path d="M11 5 6 9H3v6h3l5 4V5Z" />
            <path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13" />
        </>
    ),
    soundOff: (
        <>
            <path d="M11 5 6 9H3v6h3l5 4V5Z" />
            <path d="m22 9-6 6m0-6 6 6" />
        </>
    ),
    sun: (
        <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </>
    ),
    moon: <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11Z" />,
    download: (
        <>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <path d="m7 10 5 5 5-5M12 15V3" />
        </>
    ),
    flag: (
        <>
            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1Z" />
            <path d="M4 22v-7" />
        </>
    ),
    image: (
        <>
            <rect x="3" y="3" width="18" height="18" rx="4" />
            <circle cx="9" cy="9" r="1.8" />
            <path d="m21 15-4.5-4.5L6 21" />
        </>
    ),
    video: (
        <>
            <rect x="2.5" y="5" width="13.5" height="14" rx="3.5" />
            <path d="m16 10.5 5.5-3v9l-5.5-3" />
        </>
    ),
    sparkle: <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3ZM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z" />,
    star: <path d="m12 3 2.7 5.6 6.1.8-4.5 4.3 1.1 6.1L12 16.9 6.6 19.8l1.1-6.1L3.2 9.4l6.1-.8L12 3Z" fill="currentColor" stroke="none" />,
    user: (
        <>
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21a8 8 0 0 1 16 0" />
        </>
    ),
    logout: (
        <>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <path d="m16 17 5-5-5-5M21 12H9" />
        </>
    ),
    refresh: (
        <>
            <path d="M21 12a9 9 0 1 1-3-6.7" />
            <path d="M21 4v6h-6" />
        </>
    ),
    lock: (
        <>
            <rect x="4" y="11" width="16" height="10" rx="3" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </>
    ),
    clock: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </>
    ),
    mail: (
        <>
            <rect x="3" y="5" width="18" height="14" rx="3" />
            <path d="m3 8 9 6 9-6" />
        </>
    ),
    grid: (
        <>
            <rect x="3" y="3" width="7" height="7" rx="2" />
            <rect x="14" y="3" width="7" height="7" rx="2" />
            <rect x="3" y="14" width="7" height="7" rx="2" />
            <rect x="14" y="14" width="7" height="7" rx="2" />
        </>
    ),
};

export function Icon({ name, size = 18, strokeWidth = 2, className, ...rest }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            {...rest}
        >
            {PATHS[name]}
        </svg>
    );
}
